import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5838dfe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex items-center justify-center",
  style: { height: '100vh', width: '100vw' }
}
const _hoisted_2 = {
  class: "flex flex-col rounded-note border-2 border-charcoal relative rise-animation",
  style: { width: '360px' }
}
const _hoisted_3 = { class: "text-center mx-34 py-20" }
const _hoisted_4 = { class: "text-center ellipsis mx-34" }
const _hoisted_5 = { class: "flex mx-34 my-20 gap-12" }
const _hoisted_6 = {
  key: 0,
  class: "text-charcoal p-cell flex-grow text-center"
}
const _hoisted_7 = {
  key: 1,
  class: "text-charcoal p-cell flex-grow text-center"
}
const _hoisted_8 = {
  key: 2,
  class: "text-charcoal p-cell flex-grow text-center"
}
const _hoisted_9 = { class: "flex mx-34 mb-20 gap-12" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Taking you there ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Go Home ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AuthGuard = _resolveComponent("AuthGuard")!

  return (_openBlock(), _createBlock(_component_AuthGuard, { workspace: false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.failed ? "✋" : _ctx.joined ? "🎉" : "🤝"), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$route.params.key), 1),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.failMessage), 1))
              : (_ctx.joined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Joined! "))
                : (_ctx.joining)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Joining "))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.join && _ctx.join(...args))),
                      class: "btn-landing-negative text-charcoal p-cell rounded-mention flex-grow text-center"
                    }, " Join this workspace "))
          ]),
          (_ctx.failed)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center cursor-pointer mx-34 my-12"
              }, " login "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.joined)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: '/-/' + _ctx.workspace,
                  class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center ellipsis"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/-",
                  class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}